import {apiCurrentPermissions} from "./fetcher";
export default function useGetCurrentUserPermissions(setPermissions: any) {
    const handleGetCurrentUserPermissions = () => {
        // Get Current User Permissions
        apiCurrentPermissions()
            .then((data) => {
                if("data" in data) {
                    if("data" in data.data) {
                        setPermissions(data.data.data);
                    }
                }
            })
            .catch((response) => {
                console.error(response);
            });
    }

    return { handleGetCurrentUserPermissions };
}